import { GREY_200, GREY_500, GREY_600, GREY_700, GREY_800, GREY_900 } from "../materialColors";
export var iconColors = {
    light: {
        high: GREY_900,
        medium: GREY_800,
        low: GREY_700,
        disabled: GREY_600
    },
    dark: {
        high: GREY_200,
        medium: GREY_500,
        low: GREY_600,
        disabled: GREY_700
    }
};
